module.exports = __webpack_public_path__ + "img/category_outdoor.671f216.png";